module.exports = __webpack_public_path__ + "img/icon-localization-changes.78bbf3bb.svg";